/* eslint-disable no-unused-vars */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-console */
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import store from 'shared/store';
import { authAction, applicantAction } from 'shared/store/actions';
import ConnectedIntlProvider from 'shared/helpers/ConnectedIntlProvider';
import './App.scss';
import classNames from 'classnames';
import {
  isMobileOnly, isIOS,
  //  isMobileSafari, isIE,
} from 'react-device-detect';
import utils from 'shared/helpers/utils';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Routes from './Routes';

class App extends Component {
  componentDidMount() {
    // this.loadRecaptchaScript(window.location.pathname);

    const { token } = store.getState().authReducer;
    if (token) {
      store.dispatch(authAction.validateUserToken());
      store.dispatch(applicantAction.getApplicantDetails());
    }

    const scriptId = 'recaptcha-script';
    // Check if the script is already added
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_KEY}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
  }

  // componentDidUpdate(prevProps, prevState) {
  //   if (window.location.pathname !== prevProps.location.pathname) {
  //     this.loadRecaptchaScript(window.location.pathname);
  //   }
  // }

  // loadRecaptchaScript(pathname) {
  //   const recaptchaPages = ['/login', '/otp', '/cob-front/login', '/cob-front/otp'];

  //   if (recaptchaPages.includes(pathname)) {
  //     // Check if the script is already loaded
  //     if (!document.querySelector(`script[src="https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_KEY}"]`)) {
  //       const script = document.createElement('script');
  //       script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_KEY}`;
  //       script.async = true;
  //       script.defer = true;
  //       document.body.appendChild(script);
  //     }
  //   } else {
  //     // Optionally, remove the script if it's not needed
  //     this.removeRecaptchaScript();
  //   }
  // }

  // removeRecaptchaScript() {
  //   const script = document.querySelector(`script[src="https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_KEY}"]`);
  //   if (script) {
  //     document.body.removeChild(script);
  //     console.log('reCAPTCHA script removed');
  //   }
  // }

  render() {
    const classes = classNames({
      App: true,
      'App--desktop': !isMobileOnly,
      'App--mobileBrowser': isMobileOnly && !utils.isInStandaloneMode(),
      'App--pwa': isMobileOnly && utils.isInStandaloneMode(),
      'App--isIOS': isIOS,
    });

    return (
      <Provider store={store}>
        <ConnectedIntlProvider>
          <div className={classes} id="app">
            <Routes />
            <ToastContainer />
          </div>
        </ConnectedIntlProvider>
      </Provider>
    );
  }
}

export default App;
